import {
  Button,
  Checkbox,
  CircularProgress,
  Container,
  Divider,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  SelectChangeEvent,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import NavBar from "../../components/navbar";
import { useNavigate } from "react-router-dom";
import { LoadExternalInventoryByEan } from "../../../../domain/usecases/load-external-inventory-by-ean";
import { LoadInventoryByEan } from "../../../../domain/usecases/load-inventory-by-ean";
import { useErrorHandler } from "../../hooks";

type Props = {
  loadExternalInventory: LoadExternalInventoryByEan;
  loadInventory: LoadInventoryByEan;
};

const branchOptions = ["02", "06", "07", "71", "08", "09", "10"];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const CheckByProduct = ({ loadExternalInventory, loadInventory }: Props) => {
  const [ean, setEan] = useState("");
  const [internalAmount, setInternalAmount] = useState(0);
  const [externalAmount, setExternalAmount] = useState(0);
  const [branches, setBranches] = React.useState<string[]>(["71"]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleError = useErrorHandler((e) => {
    console.log(e.message);
  });

  const handleChange = (event: SelectChangeEvent<typeof branches>) => {
    const {
      target: { value },
    } = event;
    setBranches(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const compare = async () => {
    try {
      const external = await loadExternalInventory.load([ean], branches);
      const externalAmount = external.reduce((acc, item) => {
        acc += item.amount;
        return acc;
      }, 0);
      const warehouseString = localStorage.getItem("currentWarehouse");
      const warehouse = warehouseString
        ? (JSON.parse(warehouseString) as {
            id: number;
            name: string;
          } | null)
        : undefined;
      const internal = await loadInventory.load({
        codes: [ean],
        warehouseId: warehouse!.id,
      });
      const internalAmount = internal.reduce((acc, item) => {
        acc += item.amount;
        return acc;
      }, 0);
      setInternalAmount(internalAmount);
      setExternalAmount(externalAmount);
    } catch (error: any) {
      //handleError(error);
      console.log(error);
    }
  };
  return (
    <>
      <NavBar
        title="Relatórios"
        onBack={() => {
          navigate(-1);
        }}
      />
      <Container
        sx={{
          my: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack direction="row" spacing={4}>
          <TextField
            label="EAN"
            value={ean}
            onChange={(e) => {
              setEan(e.target.value);
            }}
          />
          <FormControl sx={{ m: 1, width: 150 }}>
            <InputLabel id="demo-multiple-checkbox-label">Filial</InputLabel>
            <Select
              labelId="demo-multiple-checkbox-label"
              label="Filial"
              placeholder="Filial"
              id="demo-multiple-checkbox"
              multiple
              value={branches}
              onChange={handleChange}
              input={<OutlinedInput label="Tag" />}
              renderValue={(selected) => selected.join(", ")}
              MenuProps={MenuProps}
            >
              {branchOptions.map((name) => (
                <MenuItem key={name} value={name}>
                  <Checkbox checked={branches.indexOf(name) > -1} />
                  <ListItemText primary={name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </Container>
      <Divider>
        <Button
          variant="contained"
          size="large"
          startIcon={
            isLoading && <CircularProgress color="secondary" size={20} />
          }
          onClick={compare}
        >
          Comparar
        </Button>
      </Divider>
      <Container sx={{ my: "50px" }}>
        <Paper
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: "20px",
          }}
        >
          <div>
            <Typography fontWeight={"bold"}>Quantidade Domus</Typography>
            <Typography>{internalAmount}</Typography>
          </div>
          <div>
            <Typography fontWeight={"bold"}>Quantidade Fiscal</Typography>
            <Typography>{externalAmount}</Typography>
          </div>
          <div>
            <Typography fontWeight={"bold"}>Diferença</Typography>
            <Typography>
              {(internalAmount - externalAmount).toFixed(4)}
            </Typography>
          </div>
        </Paper>
      </Container>
    </>
  );
};

export default CheckByProduct;
